// @owners { team: patients }
import { formatDollars } from '~shared/helpers/currency';
export const COURIER_TIP_COPY = {
  CARD_BODY: 'You can leave them a tip. Tipping is optional and 100% of your tip goes directly to your courier.',
  CARD_HEADER: 'Want to thank your courier?',
  CUSTOM_AMOUNT_LINK: 'Enter Custom Amount',
  getInfoBullets: () => {
    return [
      '100% of your tip goes directly to your courier',
      'Tips are always optional',
      'You can choose to tip during checkout or after your delivery. You’ll have up to 2 hours post-delivery to add or change your tip amount',
    ];
  },
  TOAST_SUCCESSFUL_UPDATE: 'Thank you! Your tip was successfully updated',
};

export const COURIER_NEW_TIP_COPY = {
  CARD_BODY: 'Tipping is optional. 100% of your tip goes directly to your courier.',
  CUSTOM_AMOUNT_LINK: 'Enter Custom Amount',
  INFO_BULLETS: [
    '100% of your tip goes directly to your courier',
    'Tips are always optional',
    'You can choose to tip during checkout or after your delivery. You’ll have up to 2 hours post-delivery to add or change your tip amount',
  ],
  TOAST_SUCCESSFUL_UPDATE: 'Thank you! Your tip was successfully updated',
};
// Default tip amount is set on all checkout instances, even ones that are ineligible for tips
export const DEFAULT_TIP_AMOUNT = 0;
// Initial tip amount is set when the order is eligible for tips and doesn't have a tip amount manually selected
export const INITIAL_TIP_AMOUNT = 5;
export const CUSTOM_TIP_PLACEHOLDER = '0.00';
export const MAX_TIP_AMOUNT = 100.0;
export const MAX_TIP_AMOUNT_LENGTH = MAX_TIP_AMOUNT.toFixed(2).length;
export const MIN_TIP_AMOUNT = 0.5;
export const TIP_AMOUNT_ERRORS = {
  OVER_MAX: 'Please enter a smaller tip amount',
  UNDER_MIN: `We cannot accept tips less than ${formatDollars(MIN_TIP_AMOUNT)}`,
};

export const TIP_AMOUNT_OPTIONS = [
  {
    value: 0,
    label: 'No tip',
  },
  {
    value: 3,
    label: '$3',
  },
  {
    value: 5,
    label: '$5',
  },
  {
    value: 10,
    label: '$10',
  },
];
export const TIP_AMOUNT_OPTION_VALUES = TIP_AMOUNT_OPTIONS.map((option) => option.value);

export const HOURS_TO_CREATE_OR_UPDATE_TIPS_AFTER_DELIVERY = 23;
export const MIN_RATING_TO_TIP = 4;
